import { useEffect, useState } from 'react';

// useDelayedRender returns false for the first `delayMs` after mount, then
// true. It powers the "delayed skeleton": a component renders nothing until the
// delay elapses, so a fast load — where the skeleton mounts and unmounts inside
// the window — never shows a shimmer. Only genuinely slow loads cross the
// threshold and reveal the skeleton, eliminating the flash-of-loading-state on
// snappy navigations. delayMs <= 0 renders immediately.
export function useDelayedRender(delayMs = 150): boolean {
  const [show, setShow] = useState(delayMs <= 0);
  useEffect(() => {
    if (delayMs <= 0) {
      setShow(true);
      return;
    }
    setShow(false);
    const t = setTimeout(() => setShow(true), delayMs);
    return () => clearTimeout(t);
  }, [delayMs]);
  return show;
}
